module.exports = __webpack_public_path__ + "static/media/notification-ic.ce19094e.svg";